import { MessageMedium } from 'modules/graphql/types';
import { ModalContextProvider } from 'utils/contexts/modal';
import { Editor } from './components';
import { WYSIWYGProvider } from './contexts/WYSIWYGProvider';

export type WYSIWYGEditorProps = {
  /** show/hide the 'Load HTML file...' button */
  canLoadHTML?: boolean;
  /** enable/disable the handlebars autocomplete feature */
  canUseAutoCompleteParams?: boolean;
  /** used to determine when to reset the UndoManager */
  contentLocale?: string;
  /** enable support for full HTML */
  isFullHtmlDoc?: boolean;
  /** for TinyMCE (height of the editable area in pixels as numeric; undocumented: also accepts '100%') */
  height?: number | string;
  id?: string;
  /** should be a non-changing value; include only if different than value upon mounting. In order to maintain undo states, this value should not change even when saving */
  initialValue?: string;
  /** the last value successfully saved (used for diff comparisons) */
  lastSavedValue?: string;
  /** used with canUseAutoCompleteParams whenever applicable (template editing) */
  messageMedium?: MessageMedium;
  /** controlled component onChange handler for content value */
  onChange: (content: string) => void;
  /** controlled component content value */
  value: string;
};

export const WYSIWYGEditor = ({
  initialValue = '',
  value = '',
  isFullHtmlDoc = false,
  canLoadHTML = false,
  lastSavedValue = '',
  onChange,
  ...wysiwygProps
}: WYSIWYGEditorProps) => {
  const providerProps = {
    initialValue,
    value,
    lastSavedValue,
    onChange,
    isFullHtmlDoc,
    canLoadHTML,
  };

  return (
    <WYSIWYGProvider {...providerProps}>
      <ModalContextProvider>
        <Editor {...wysiwygProps} />
      </ModalContextProvider>
    </WYSIWYGProvider>
  );
};
